// eslint-disable-next-line no-underscore-dangle
window._learnq = window._learnq || [];
// eslint-disable-next-line no-underscore-dangle
export const learnq = window._learnq;

export const trackKlaviyoAddedToCart = (rootPrefix, requestCartConfig) => {
  if (!learnq) return;

  fetch(`${rootPrefix}cart.js`, requestCartConfig)
    .then(response => {
      if (!response.ok) {
        throw response;
      }
      return response.json();
    })
    .then(data => {
      const items = data.items.map(item => {
        const adjustedItem = item;
        // Put all object key prices in an array
        const priceKeys = [
          'discounted_price',
          'final_line_price',
          'final_price',
          'line_level_total_discount',
          'line_price',
          'original_line_price',
          'original_price',
          'price',
          'total_discount',
        ];

        // Format prices: loop through the array and divide the price by 100
        priceKeys.forEach(key => {
          const keyValue = adjustedItem[key];
          if (keyValue && keyValue !== 0) {
            adjustedItem[key] = keyValue / 100;
          }
        });

        return adjustedItem;
      });

      const cart = {
        total_price: data.total_price / 100,
        $value: data.total_price / 100,
        total_discount: data.total_discount / 100,
        original_total_price: data.original_total_price / 100,
        items,
      };

      learnq.push(['track', 'Added to Cart', cart]);
    });
};
